import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackCanvasCreated.meta';

export type UseTrackCanvasCreatedParams = {
  canvas_id: string;
  library_id?: string;
  board_id?: string;
  source?:
    | 'board'
    | 'library'
    | 'general_library'
    | 'asset_selection_bar'
    | 'all_content_header'
    | 'canvases'
    | 'try_canvas_cta'
    | 'board_canvas_open'
    | 'all_content_canvas_open';
};

export const useTrackCanvasCreated = () => {
  const { track } = useAnalyticsUtilities();

  const trackCanvasCreated = useCallback(
    (params: UseTrackCanvasCreatedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackCanvasCreated };
};
